    <div class="card-skeleton">
      <div class="card-skeleton__image"></div>
      <div class="card-skeleton__body">
        <div class="card-skeleton__line card-skeleton__line--title"></div>
        <div class="card-skeleton__line card-skeleton__line--sub"></div>
        <div class="card-skeleton__row">
          <div class="card-skeleton__line card-skeleton__line--meta"></div>
          <div class="card-skeleton__line card-skeleton__line--price"></div>
        </div>
      </div>
    </div>
